import { useAppSelector } from "../../store/store";

export const useMainLayout = () => {
    const { openDrawer } = useAppSelector((state) => state.layout);
    
    return { openDrawer }
}